import { Component, effect, signal } from '@angular/core';
import { ToastService } from './toast.service';
import { InitFlowbiteFix } from '../../directive';

@Component({
  selector: 'ui-toast',
  standalone: true,
  imports: [],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
})
export class ToastComponent {
  ios = this.iOS()
  toasts = signal<
    {
      message: string;
      duration: number;
      type: 'success' | 'danger' | 'warning';
    }[]
  >([]);

  constructor(private toastService: ToastService) {
    effect(
      () => {
        this.toasts.set(toastService.toasts());
        InitFlowbiteFix();
      },
      { allowSignalWrites: true }
    );
  }

  remove(index: number) {
    this.toastService.remove(index);
  }
 iOS() {
    const isIOS = ![
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    return isIOS
  }
}
